import { Like } from "@css/icons/Like"
import { useFavorite } from "@utils/hooks/useFavorite"
import { updateListingLike } from "../listings-page-utils"
import { MouseEvent } from "react"

type Props = {
    className?: string
    id: number
}
export function FavoriteBtn({ className, id }: Props) {
    const isFavorite = useFavorite(id)
    const onLike = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        e.stopPropagation()
        updateListingLike({ id, like: !isFavorite })
    }
    return (
        <button onClick={onLike} className={className} data-active={isFavorite} aria-label="toggle favorite">
            <Like />
        </button>
    )
}
